import React, { useEffect, useState } from 'react';
import api from '../axios/api';
import Grid from '../components/common/Grid';
import { Box } from '@mui/material';

const TopUsersTable = () => {
  const [users, setUsers] = useState([]);
  const [totalCounts, setTotalCounts] = useState({ totalPosts: 0, totalOther: 0, totalUploads: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopUsers = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/User/topUsers');
        const data = Array.isArray(response.data) ? response.data : [];
        setUsers(data);

        // Calculate totals
        let totalPosts = 0;
        let totalVerified = 0;
        let totalPoints = 0;

        data.forEach((user) => {
          totalPosts += parseInt(user.totalTrees, 10) || 0;
          totalVerified += parseInt(user.verifiedTrees, 10) || 0;
          totalPoints += parseInt(user.redeemed_points, 10) || 0;
        });

        setTotalCounts({ totalPosts, totalVerified, totalPoints });
      } catch (error) {
        console.error('Error fetching top users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopUsers();
  }, []);

  const columns = [
    {
      header: 'Profile',
      width: '12%',
      align: 'center',
      render: (_, user) => (
        <a
          href={`/userprofile/${user.id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block' }}
        >
          <img
            src={user.userProfilePic || '/images/default-avatar.png'}
            alt={user.userName || user.full_name}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover',
              transition: 'transform 0.3s, box-shadow 0.3s',
              verticalAlign: 'middle',
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/images/default-avatar.png';
            }}
          />
        </a>
      ),
    },
    {
      header: 'Name',
      align: 'left',
      sortable: true,
      accessor: 'full_name',
      render: (name, user) => (
        <a
          href={`/userprofile/${user.id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontWeight: 'bold',
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          {name || user.userName || 'Anonymous'}
        </a>
      ),
    },
    {
      header: 'Plants',
      align: 'center',
      sortable: true,
      accessor: 'totalTrees',
      render: (val) => val ?? 0,
    },
    {
      header: 'Verified',
      align: 'center',
      sortable: true,
      accessor: 'verifiedTrees',
      render: (val) => val ?? 0,
    },
    {
      header: 'Reward Points Earned',
      align: 'center',
      sortable: true,
      accessor: 'redeemed_points',
      render: (val) => val ?? 0,
    },
  ];

  const footer = [
    { content: <span style={{ fontWeight: 'bold' ,color:"black"}}>Total</span>, align: 'center' },
    { content: '' },
    { content: <span style={{ fontWeight: 'bold' ,color:"black"}}>{totalCounts.totalPosts}</span>, align: 'center' },
    { content: <span style={{ fontWeight: 'bold',color:"black" }}>{totalCounts.totalVerified}</span>, align: 'center' },
    { content: <span style={{ fontWeight: 'bold',color:"black" }}>{totalCounts.totalPoints}</span>, align: 'center' },
  ];

  return (
    <>
      <section className="bg-image pt-25 pb-25">
        <div className="container">
          <h2 className="Banner-Title">Leaders</h2>
        </div>
      </section>

      <Box sx={{  margin: '0 auto', padding: '30px 15px' }}>
        <Grid
          columns={columns}
          data={users}
          loading={loading}
          footer={footer}
          variant="navy"
          // pagination={true}
          // pageSize={10}
          // pageSizeOptions={[5, 10, 20, 50]}
          // searchable={true}
          // searchPlaceholder="Search leaders..."
        />
      </Box>
    </>
  );
};

export default TopUsersTable;